import React, { useContext } from 'react';
import styles from './PoliceReportList.styles.js';
import usePoliceReportListHook from './PoliceReportList.hook.js';
import DefaultLayout from 'Components/DefaultLayout/DefaultLayout.jsx';
import { AppContext } from 'App.context.js';
import BaseTable from 'Components/common/BaseTable/BaseTable.jsx';
import PoliceReportCaption from '../../PoliceReportCaption/PoliceReportCaption.jsx';
import DotIndicator from 'Components/common/DotIndicator/DotIndicator.jsx';
import { capitalize } from 'utils/TextUtils.js';
import {
  Button,
  DatePicker,
  Popover,
  Alert,
  Table,
  Divider,
  Descriptions,
  Badge,
  List,
} from 'antd';
import { WarningOutlined, EyeOutlined, CloseSquareFilled } from '@ant-design/icons';
import moment from 'moment';
import AppInput from 'Components/common/AppInput/AppInput.jsx';
import AppInputTypes from 'Components/common/AppInput/AppInputTypes.js';
import AppButton from 'Components/common/Forms/AppButton/AppButton.jsx';
import Colors from 'constants/Colors.js';
import Loading from 'Components/common/Loader/Loading.jsx';
import constants from '../../../../../utils/constants.js';
import ITAgetColumns from '../Config/AlloggiatiPoliceReportList.config.js';
import SESgetColumns from '../Config/SESBookingsReportList.config.js';
import AppModal from 'Components/common/AppModal/AppModal.jsx';
import RequestSuscription from 'Components/common/RequestSuscription/RequestSuscription.jsx';
import { actionTypes } from 'Sell/CrossSell/Item/Upsert/FormItem/reducer.js';

const { RangePicker } = DatePicker;

export default function PoliceReportList() {
  const { state, actions } = usePoliceReportListHook();
  const {
    appState,
    appActions: { translate, getSelectedHotel },
  } = useContext(AppContext);

  let stateRow;
  if (state.platform === constants.POLICE_REPORT_PLATFORMS.SES) {
    stateRow = {
      title: translate('policeReport.statusCol'),
      dataIndex: 'status',
      key: 'status',
      sorter: false,
      filterMultiple: false,
      filters: [
        { text: 'Ok', value: 'ok' },
        { text: 'Error', value: 'error' },
        { text: 'Pending', value: 'pending' },
      ],
      defaultFilteredValue: state.filters?.status ? [state.filters?.status] : [],

      render: (status, object) => {
        const resvStatus = object.resvStatus || null;
        let statusText;

        if (status === 'ok') {
          statusText =
            resvStatus === 'B'
              ? translate('policeReport.captionCancelledOk')
              : translate('policeReport.captionOk');
        } else if (status === 'error') {
          statusText =
            actions.parseError(object.error, object) ||
            translate(`policeReport.ses.status.${status}`);
        } else {
          statusText = translate(`policeReport.ses.status.${status}`);
        }
        if (resvStatus === 'B' && statusText.includes('lote previamente no reportado')) {
          return (
            <div style={styles.statusContainer}>
              <DotIndicator color={actions.getColorForStatus(object.status)} />
              {statusText}
              <Popover
                content={translate('policeReport.cancelledNotReportedMessage')}
                trigger="hover"
              >
                <WarningOutlined style={styles.popOverStyle} />
              </Popover>
            </div>
          );
        } else {
          return (
            <div style={styles.statusContainer}>
              <DotIndicator color={actions.getColorForStatus(object.status)} />
              <div>
                {statusText}
                {object.status === 'error' && !object.batch && (
                  <Popover content={translate('policeReport.noBatchReportedError')} trigger="hover">
                    <WarningOutlined style={styles.popOverStyle} />
                  </Popover>
                )}
              </div>
            </div>
          );
        }
      },
    };
  } else {
    // MOSSOS ERTZ uses same traductions change if needed
    stateRow = {
      title: translate('policeReport.statusCol'),
      dataIndex: 'status',
      key: 'status',
      sorter: false,
      filterMultiple: false,
      filters: [
        { text: 'Ok', value: 'ok' },
        { text: 'Error', value: 'error' },
        { text: 'Pending', value: 'pending' },
      ],
      defaultFilteredValue: state.filters?.status ? [state.filters?.status] : [],

      render: (status, object) => {
        const resvStatus = object.resvStatus || 'A';

        const statusText =
          resvStatus === 'B'
            ? translate('policeReport.ses.caption.captionCancelledOk')
            : status === 'error'
              ? actions.parseError(object.error, object) ||
                translate(`policeReport.ses.status.${object.status}`)
              : translate(`policeReport.ses.status.${object.status}`);

        return (
          <div style={styles.statusContainer}>
            <DotIndicator color={actions.getColorForStatus(object.status)} />
            <div>{statusText}</div>
          </div>
        );
      },
    };
  }
  const platform = state.platform;
  let columns;
  switch (platform) {
    case constants.POLICE_REPORT_PLATFORMS.SES:
      columns = SESgetColumns(translate, actions, state);
      break;
    case constants.POLICE_REPORT_PLATFORMS.ERTZANTZA: // Using same for ses
      columns = SESgetColumns(translate, actions, state);
      break;
    case constants.POLICE_REPORT_PLATFORMS.MOSSOS: // Usin same as ses
      columns = SESgetColumns(translate, actions, state);
      break;

    // case constants.POLICE_REPORT_PLATFORMS.ITALIAN:
    //   columns = ITAgetColumns(translate, actions, state)
    //   break;

    default:
      columns = SESgetColumns(translate, actions, state);
  }

  columns.unshift(stateRow);

  return (
    <DefaultLayout singleBox title={translate('bookingList.title')} enableAllHotels={false}>
      {state.suscription ? (
        <div style={{ ...styles.container }}>
          <div style={{ ...styles.container, padding: 5 }}>
            <div style={{ ...styles.buttonContainer }}>
              <PoliceReportCaption platform={state.platform} />
            </div>

            <div style={{ ...styles.TextContainer }}>
              {platform && (
                <p>
                  {translate('policeReport.statusTable.platform')}:{' '}
                  {translate(`policeReport.${platform}.${platform}`)}
                </p>
              )}
              {state?.statusSendReport && (
                <p>
                  {translate('policeReport.statusTable.reservationRetrievalStatus')}:{' '}
                  {translate(`policeReport.statusTable.status.${state.statusSendReport}`)}
                </p>
              )}
              {/* {state?.statusSendReport && (
                <p>
                  {translate('policeReport.statusTable.send')}:{' '}
                  {translate(`policeReport.statusTable.status.${state.statusSendReport}`)}
                  {state.InterfaceType === 'PMS' && state.statusSendReport === 'error' && (
                    <Popover content={translate('policeReport.retrySendingPMS')} trigger="hover">
                      <WarningOutlined style={styles.popOverStyle} />
                    </Popover>
                  )}
                </p>
              )} */}

              {state?.InterfaceType && (
                <p>
                  {translate('policeReport.statusTable.interfacePlatform')}: {state.InterfaceType}
                </p>
              )}

              {state.InterfaceType === 'SFTP' && state.sendTimestamp && state.fileSearchError && (
                <>
                  <p>
                    {translate('policeReport.statusTable.searchFileTimestamp')}:{' '}
                    {state.sendTimestamp}
                  </p>

                  {state.fileSearchError?.toLowerCase()?.includes('no such file') ? (
                    // File not found case
                    <p>
                      {translate('policeReport.statusTable.fileNotFound')}: {state.fileSearchError}
                      <Popover
                        content={translate('policeReport.retrySendingFileNotFound')}
                        trigger="hover"
                      >
                        <WarningOutlined style={styles.popOverStyle} />
                      </Popover>
                    </p>
                  ) : (
                    // General error case
                    <p>
                      Error: {state.fileSearchError}
                      <Popover
                        content={translate('policeReport.warningSFTPSendError')}
                        trigger="hover"
                      >
                        <WarningOutlined style={styles.popOverStyle} />
                      </Popover>
                    </p>
                  )}
                </>
              )}
            </div>
            {state.platform === constants.POLICE_REPORT_PLATFORMS.ERTZANTZA &&
              !state.hasErtzFileConfig && (
                <Alert
                  message="Ya disponible nueva configuracion para la ERTZAINTZA contacte con su administrador y complete la configuracion para poder hacer los envios automaticos."
                  type="warning"
                />
              )}
            {state.platform === constants.POLICE_REPORT_PLATFORMS.SES && (
              <>
                <Alert type="warning" message={translate('policeReport.noBatchReportedError')} />
              </>
            )}
            <div style={{ ...styles.header, justifyContent: 'flex-end' }}>
              <AppButton
                text={
                  !state.isForcedPoliceReport
                    ? translate('policeReport.forceDownloadTrigger')
                    : translate('policeReport.forcedDownloadTrigger')
                }
                action={actions.forcePoliceReportDownloadTrigger}
                disabled={
                  state.isForcedPoliceReport ||
                  !state.date ||
                  state.dataSource?.totalItems > 0 ||
                  appState.role === 'guest' ||
                  state.isLoading
                }
              />
              <AppButton
                text={translate('policeReport.downloadAllFilesButton')}
                action={actions.sendGetFiles}
                disabled={
                  state.dataSource?.totalItems === 0 ||
                  !state.date ||
                  appState.role === 'guest' ||
                  state.isLoading
                }
              />
              <AppButton
                text={translate('policeReport.sendAllErrorsButton')}
                action={actions.sendAllErrors}
                // disabled={
                //   state.dataSource?.totalItems === 0 || appState.role === 'guest' || state.isLoading
                // }
                //TODO enable when new endpoint is done

                disabled={true}
              />
              {appState.superUser && (
                <AppButton
                  disabled={state.isLoading || state.dataSource?.totalItems === 0}
                  action={() => actions.onDeleteAllDayClicked()}
                  text={translate('policeReport.sideItem.delete.button')}
                  redButton={true}
                />
              )}

              {state.isLoadingForcePoliceReport && <Loading size={'small'} color={'white'} />}
              <div style={styles.datePicker}>
                <AppInput
                  value={state.date}
                  onChange={(_, date) => actions.onDateSet(date)}
                  type={AppInputTypes.DATE}
                  disabled={state.isLoading && !state.isReportLoading}
                  bgColor={Colors.white}
                  disabledDate={current => {
                    return current && current.isSameOrAfter(moment().startOf('day'));
                  }}
                />
              </div>
            </div>
          </div>
          {state.ftpErrors.length > 0 && state.isValidation && (
            <div>
              <div style={styles.credentialsContainer}>
                <ul>
                  {state.ftpErrors.map((file, index) => (
                    <li key={index} style={{ color: 'red', fontWeight: 'bold' }}>
                      {file.message}
                    </li>
                  ))}
                  <br />
                  <p style={{ color: 'red', fontWeight: 'bold' }}>
                    {translate('policeReport.noReportsErrorInFileValidation')}
                  </p>
                </ul>
              </div>
            </div>
          )}
          <div style={styles.whiteBackground}>
            <BaseTable
              columns={columns}
              data={state.dataSource}
              loading={state.isLoading}
              onChange={filters => actions.onChange(filters)}
              currentPage={state.dataSource.page}
            />

            <AppModal // all day
              show={state.showAllDayDeleteWarning}
              title={translate('policeReport.sideItem.delete.warning.title')}
              description={translate('policeReport.sideItem.delete.warning.description')}
              okText={translate('Ok')}
              okAction={actions.sendDeleteAll}
              cancelAction={() => actions.setShowDeleteAllWarning(false)}
              closable={false}
            />
          </div>
        </div>
      ) : (
        <RequestSuscription suscription="bookings_report" />
      )}
    </DefaultLayout>
  );
}
